import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
// 登录验证
export default new Vuex.Store({
	state: {
		// 当前路由
		nowPathUrl: ''
	},
	getters: {

	},
	mutations: {
		// 记录当前路由
		changePathUrl(state, param) {
			state.nowPathUrl = param
		}
	},
	actions: {

	}
})
